// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blastoise_gmax: PokeData = {
  "id": 10197,
  "name": "blastoise-gmax",
  "height": 250,
  "weight": 10000,
  "base_experience": 239,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [],
  "moves": [
    "brine",
    "life-dew",
    "bubble",
    "bubble-beam",
    "hydro-pump",
    "aqua-cutter",
    "aqua-jet",
    "aqua-tail",
    "whirlpool",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 3,
    "item": null,
    "species": [
      {
        "name": "squirtle",
        "order": 7,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wartortle",
        "order": 8,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 7,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blastoise",
        "order": 9,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 8,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 123,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
